import { render, staticRenderFns } from "./StudioGetResetPassword.vue?vue&type=template&id=659598a4&"
import script from "./StudioGetResetPassword.vue?vue&type=script&lang=ts&"
export * from "./StudioGetResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports